import { Toast } from 'vant'

const orginKey = '2929292929292929'
const orginIv = '3131313131313131'

const utils = {
}

utils.Encrypt = (word) => {
  var AES = require('crypto-js/aes')
  var Latin1 = require('crypto-js/enc-latin1')
  var zeropadding = require('crypto-js/pad-zeropadding')
  const key = Latin1.parse(orginKey)
  const iv = Latin1.parse(orginIv)
  const encoded = AES.encrypt(word, key, {
    iv: iv,
    adding: zeropadding
  }).toString()
  return encoded
}

utils.Decrypt = (word) => {
  var AES = require('crypto-js/aes')
  var Latin1 = require('crypto-js/enc-latin1')
  var Utf8 = require('crypto-js/enc-utf8')
  var zeropadding = require('crypto-js/pad-zeropadding')
  const key = Latin1.parse(orginKey)
  const iv = Latin1.parse(orginIv)
  const decoded = AES.decrypt(word, key, {
    iv: iv,
    adding: zeropadding
  }).toString(Utf8)
  return decoded
}

utils.getBase64 = (url, callback) => {
  // 通过构造函数来创建的 img 实例，在赋予 src 值后就会立刻下载图片，相比 createElement() 创建 <img> 省去了 append()，也就避免了文档冗余和污染
  var Img = new Image()
  var dataURL = ''
  Img.src = url + '?v=' + Math.random() // 处理缓存,fix缓存bug,有缓存，浏览器会报错;
  Img.setAttribute('crossOrigin', 'Anonymous') // 解决控制台跨域报错的问题
  Img.onload = function () { // 要先确保图片完整获取到，这是个异步事件
    var canvas = document.createElement('canvas') // 创建canvas元素
    var width = Img.width // 确保canvas的尺寸和图片一样
    var height = Img.height
    canvas.width = width
    canvas.height = height
    canvas.getContext('2d').drawImage(Img, 0, 0, width, height) // 将图片绘制到canvas中
    dataURL = canvas.toDataURL('image/jpeg') // 转换图片为dataURL
    callback ? callback(dataURL) : null // 调用回调函数
  }
}

utils.convertTime = (time) => {
  const hours = parseInt((time % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
  const minutes = parseInt((time % (1000 * 60 * 60)) / (1000 * 60))
  const seconds = parseInt((time % (1000 * 60)) / 1000)

  let deadLineTime = {}
  deadLineTime.hours = hours
  deadLineTime.minutes = minutes
  deadLineTime.seconds = seconds

  return deadLineTime
}

utils.isMiniprogram = (eventType) => {
  if (window.__wxjs_environment === eventType) {
    return true
  }
  return false
}

// base 64图片转 Blob对象
utils.convertBase64UrlToBlob = (urlData) => {
  var bytes = window.atob(urlData.split(',')[1]) // 去掉url的头，并转换为byte
  // 处理异常,将ascii码小于0的转换为大于0
  var ab = new ArrayBuffer(bytes.length)
  var ia = new Uint8Array(ab)
  for (var i = 0; i < bytes.length; i++) {
    ia[i] = bytes.charCodeAt(i)
  }
  return new Blob([ab], { type: 'image/png' })
}

utils.formatDate = (date) => {
  let y = date.getFullYear()
  let m = date.getMonth() + 1
  m = m < 10 ? '0' + m : m
  let d = date.getDate()
  d = d < 10 ? '0' + d : d

  let h = date.getHours()
  h = h < 10 ? '0' + h : h
  let t = date.getMinutes()
  t = t < 10 ? '0' + t : t

  return y + '-' + m + '-' + d + ' ' + h + ':' + t
}

utils.formatActivityDate = (date) => {
  let y = date.getFullYear()
  let m = date.getMonth() + 1
  m = m < 10 ? '0' + m : m
  let d = date.getDate()
  d = d < 10 ? '0' + d : d

  let h = date.getHours()
  h = h < 10 ? '0' + h : h
  let t = date.getMinutes()
  t = t < 10 ? '0' + t : t

  return y + '年' + m + '月' + d + '日' + ' ' + h + ':' + t
}

utils.getQueryString = (name) => {
  const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`, 'i')
  const r = window.location.search.substr(1).match(reg)
  if (r != null) { return unescape(r[2]) }
  return null
}

export function handleError (res, _msg) {
  Toast(_msg || (res && res.msg) || '服务器出了点小差')
}

export default utils
